<template>
    <div class="travel-quote-step trip-info">

        <quote-step-header
            :title="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        />

        <form class="quote-form" @submit.prevent="next">

            <div class="extra-coverage-container">

                <extra-item
                    v-for="item in extraCoverage"
                    :key="item.name"
                    :title="item.title"
                    :icon="item.icon"
                    :name="item.name"
                    :form="form"
                    :stepName="stepName"
                    className="no-gap"
                />

            </div>

            <div class="submit-row">

                <app-button
                    :disabled="disabledConditions"
                    :loading="loading"
                >
                    {{ "quote.welcome.next" | __ }}
                </app-button>

                <button
                    type="button"
                    @click="skipExtraCoverage"
                    class="skip-extra-coverage"
                >
                    {{ trans("skip_extra_coverage") }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import ExtraItem from "./extra-coverages/ExtraItem.vue";
import arrow from "../../../../images/icons/blue-arrow.svg";

export default {
    components: { ExtraItem },
    name: "TravelQuoteExtraCoverage",
    mixins: [QuoteStep],
    props: {},

    data() {
        return {
            subSteps: ["default"],
            extraCoverage: [
                {
                    title: this.trans("items.short_flight"),
                    icon: "flight",
                    name: "cancelFlight"
                },
                {
                    title: this.trans("items.car_rent"),
                    icon: "car",
                    name: "cancelCarRent"
                },
                {
                    title: this.trans("items.phone"),
                    icon: "phone",
                    name: "phoneCoverage"
                },
                {
                    title: this.trans("items.electronic"),
                    icon: "laptop",
                    name: "laptopCoverage"
                },
                {
                    title: this.trans("items.luggage"),
                    icon: "luggage",
                    name: "luggage"
                },
                {
                    title: this.trans("items.sport_equipment"),
                    icon: "equipment",
                    name: "sport_equipment"
                },
                {
                    title: this.trans("items.winter"),
                    icon: "winter",
                    name: "winter"
                },
                // {
                //     title: this.trans("items.third_party"),
                //     icon: "third_party",
                //     name: "third_party"
                // },
                // {
                //     title: this.trans("items.search_and_rescue"),
                //     icon: "search_and_rescue",
                //     name: "search_and_rescue"
                // }
            ],
            arrow
        };
    },
    methods: {
        skipExtraCoverage() {
            // return  Object.entries(this.form[this.stepName]).map(([key, value]) => {
            //     console.log('key', key, 'value', value)
            // })
            //  this.form[this.stepName] = [];
            this.form[this.stepName] = {
                cancelFlight: false,
                cancelCarRent: false,
                phoneCoverage: false,
                laptopCoverage: false,
                luggage: false,
                sport_equipment: false,
                winter: false,
                // third_party: false,
                // search_and_rescue: false
            };
            this.next();
        }
    },
    computed: {
        canMoveNext() {
            return Object.values(this.form[this.stepName]).some(item => item);
        }
    }
};
</script>

<style lang="scss" scoped>
.extra-coverage-container {
    display: flex;
    place-content: center;
    flex-wrap: wrap;
    gap: 10px;
}

.coverage_details {
    color: #185af5;
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 10px;
    font-weight: $font-bold;
}

.submit-row {
    margin: 80px auto;
    text-align: center;
    display: flex;
    flex-direction: column;

    .skip-extra-coverage {
        font-weight: $font-semi-bold;
        display: block;
        margin: 20px auto;
    }
}
</style>
